/* unplugin-vue-components disabled */
import AIChat from 'components/ai-chat'
import {AddPrompt} from 'components/prompts'
import {Chat} from 'stores/chats'
import {computed} from 'vue'
import $global from 'stores/global'
import ChatHeader from './chat-header.vue'
import ShareModal from './chat-sharing/share-modal.vue'

export default {
  components: {AIChat, ShareModal, AddPrompt, ChatHeader},
  provide() {
    return {
      di_apollo: computed(() => this.apollo_data),
      di_chat_mode: computed({
        get: () => this.chat.mode,
        set: mode => this.chat.setMode(mode)
      })
    }
  },
  props: {
    chat: {
      type: Chat,
      required: true
    }
  },
  data() {
    return {
      sources: undefined,
      apollo_data: new Map(),
      onLike: $utils.timers.debounce((idx, feedback) => this.chat.like(idx, feedback), 200),
      onDislike: $utils.timers.debounce((idx, feedback) => this.chat.dislike(idx, feedback), 200),
      onSave: $utils.timers.debounce((index, text) => this.chat.savePost(index, text), 400),
      onMeetingSave: $utils.timers.debounce((index) => this.saveMeeting(index), 400),
      onDocumentSave: $utils.timers.debounce((index) => this.saveDocument(index), 400),
      onPodcastSave: $utils.timers.debounce((index) => this.savePodcast(index), 400),
    }
  },
  computed: {
    loading() {
      return this.chat.loading
    },
    chat_id() {
      return this.chat.id
    },
    generating() {
      return this.chat.generating
    },
    intermediate(){
      return this.chat.history?.at(-1)?.intermediate
    },
    readonly() {
      return this.chat.readonly
    },
    ref_history_len() {
      return this.chat.ref_history_len
    },
    can_share() {
      return !this.loading && !!$global.chatSharingEnabled && !!this.chat_id
    },
    shared(){
      return !!this.chat.share
    }
  },
  watch: {
    async loading(value) {
      if (value || this.$responsive.mobile || this.generating || this.intermediate) return
      await this.$nextTick()
      this.$refs.chat?.focus()
    }
  },
  beforeUnmount() {
    this.onLike.abort()
    this.onDislike.abort()
    this.onSave.abort()
  },
  created() {
    this.$listen('meeting-save', this.onMeetingSave)
    this.$listen('document-save', this.onDocumentSave)
    this.$listen('answer-ai', this.onAnswerAi)
  },
  mounted() {
    if (this.loading || this.$responsive.mobile || this.generating || this.intermediate) return
    this.$refs.chat.focus()
  },
  methods: {
    share(){
      this.$refs.share.open()
    },
    async onChat(params) {
      await this.chat.doChat(params)
    },
    async onAnswerAi(params){
      await this.chat.doChat(params, true)
    },
    onStop() {
      this.chat.stopChat()
    },
    async onRegenerateFragment(history_idx, range) {
      await this.chat.regenratePostFragment(history_idx, range.start_idx, range.end_idx)
    },
    async saveMeeting(history_idx) {
      await this.chat.doChat({
        text: 'Create a presentation....',
        command: 'generate_presentation',
        command_args: {history_idx}
      })
    },
    async savePodcast(history_idx) {
      await this.chat.doChat({
        text: 'Create a Prep Podcast episode',
        command: 'generate_audio',
        command_args: {history_idx}
      })
    },
    async onReasoning(ev) {
      this.chat.updateReasoning(ev)
    },
    async saveDocument(ev) {
      let text = 'Please create a pdf document'
      if (ev.ext === 'docx'){
        text = 'Please create a Microsoft Word document'
      }
      await this.chat.doChat({
        text: text,
        command: 'generate_document',
        command_args: ev
      })
    },
    onPromptSave(idx) {
      const data = this.chat.history[idx].data
      const title = data.title?.substr(0, 256) || ''
      this.$refs.prompts.open({title, prompt: data.text.substr(0, 2048)})
    },
  }
}
